import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import TableInfo from './TableInfo'
import Spinner from 'components/Spinner'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import _ from 'lodash'
// import ListConsosComponent from './ListConsosComponent'
import SideBarConsosComponent from 'components/SideBarConsosComponent'
const styles = theme => ({
  container: {
    position: 'relative',
    overflow: 'hidden'
  }
})
const propTypes = {
  classes: PropTypes.object.isRequired,
  transaction: PropTypes.object,
  products: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  changeReducConso: PropTypes.func.isRequired,
  pricings: PropTypes.array.isRequired,
  players: PropTypes.array.isRequired,
  match: PropTypes.object.isRequired,
  addConso: PropTypes.func.isRequired,
  removeConso: PropTypes.func.isRequired,
  selectCurrentTransaction: PropTypes.func.isRequired,
  prepareForPayment: PropTypes.func.isRequired,
  playTransaction: PropTypes.func.isRequired,
  pauseTransaction: PropTypes.func.isRequired,
  updateCyclePricing: PropTypes.func.isRequired,
  updateCyclePlayers: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired
}

class TableComponent extends Component {
  componentWillReceiveProps(nextProps) {
    const { transaction } = nextProps
    if (!transaction) {
      this.props.selectCurrentTransaction(
        nextProps.match.params.tableId,
        'POOL'
      )
      return
    }
    if (
      !transaction.pool ||
      !transaction.pool.table ||
      transaction.pool.table.key !== nextProps.match.params.tableId
    ) {
      this.props.selectCurrentTransaction(
        nextProps.match.params.tableId,
        'POOL'
      )
      return true
    }
    return false
  }
  componentWillMount() {
    const { transaction } = this.props
    if (!transaction) {
      this.props.selectCurrentTransaction(
        this.props.match.params.tableId,
        'POOL'
      )
      return
    }
    if (
      !transaction.pool ||
      !transaction.pool.table ||
      transaction.pool.table.key !== this.props.match.params.tableId
    ) {
      this.props.selectCurrentTransaction(
        this.props.match.params.tableId,
        'POOL'
      )
    }
  }
  renderSpinner() {
    return <Spinner />
  }
  render() {
    const { classes, transaction, pricings, players } = this.props
    if (!transaction) return this.renderSpinner()
    const { pool, products } = transaction
    if (!pool) return this.renderSpinner()
    let productsArray = []
    if (products) {
      productsArray = _.orderBy(
        Object.keys(products).map(key => ({ ...products[key], key: key })),
        ['createdAt'],
        ['asc']
      )
    }
    return (
      <Grid
        className={classes.container}
        item
        container
        direction="row"
        alignItems="stretch"
        justify="flex-start"
        spacing={8}>
        <Grid item xs={12} md={8}>
          <TableInfo
            showModal={this.props.showModal}
            transaction={this.props.transaction}
            pricings={pricings}
            players={players}
            updateCyclePricing={this.props.updateCyclePricing}
            updateCyclePlayers={this.props.updateCyclePlayers}
            prepareForPayment={this.props.prepareForPayment}
            playTransaction={this.props.playTransaction}
            pauseTransaction={this.props.pauseTransaction}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <SideBarConsosComponent
            addModal
            showModal={this.props.showModal}
            changeReduc={this.props.changeReducConso}
            allProducts={this.props.products}
            categories={this.props.categories}
            transaction={transaction}
            products={productsArray || []}
            addConso={this.props.addConso}
            removeConso={this.props.removeConso}
          />
        </Grid>
      </Grid>
    )
  }
}

TableComponent.propTypes = propTypes
export default withRouter(withStyles(styles)(TableComponent))



// WEBPACK FOOTER //
// ./src/routes/Table/components/TableComponent.js